module.exports = __webpack_public_path__ + "static/media/looqu1.f8867138.png";